export interface SearchSubmission { readonly query: string }
type SubmissionState = { status: 'idle' } | { status: 'resolving'; submission: SearchSubmission };
type GeometryState = { status: 'idle' } | { status: 'loading'; controller: AbortController };

/** Own submitted queries and their geometry work across the map search surfaces. */
export function createSearchSession() {
  let submission: SubmissionState = { status: 'idle' };
  let geometry: GeometryState = { status: 'idle' };
  function cancelGeometry() {
    if (geometry.status === 'loading') geometry.controller.abort();
    geometry = { status: 'idle' };
  }
  function cancel() { submission = { status: 'idle' }; cancelGeometry(); }
  const accepts = (attempt: SearchSubmission) => submission.status === 'resolving' && submission.submission === attempt;
  return {
    begin(query: string): SearchSubmission | null {
      if (submission.status === 'resolving' && submission.submission.query === query) return null;
      cancel();
      const attempt = { query };
      submission = { status: 'resolving', submission: attempt };
      return attempt;
    },
    accepts,
    finish(attempt: SearchSubmission) { if (accepts(attempt)) submission = { status: 'idle' }; },
    loadGeometry(): AbortController {
      cancelGeometry();
      const controller = new AbortController();
      geometry = { status: 'loading', controller };
      return controller;
    },
    acceptsGeometry(controller: AbortController): boolean { return geometry.status === 'loading' && geometry.controller === controller && !controller.signal.aborted; },
    finishGeometry(controller: AbortController) { if (geometry.status === 'loading' && geometry.controller === controller) geometry = { status: 'idle' }; },
    cancel,
  };
}
